import React, { useRef, useEffect, useImperativeHandle, createRef, useState } from "react";
import { observer } from "mobx-react-lite"
import { appStore } from "../../stores/AppStore";
import { GLOBAL_MODALS } from "../../stores/modals";
import { get } from "../../lib/http";
import "./ProfileView.css"

const { Segment, Loader } = require("semantic-ui-react")


let sectionsInEdit = []
const setSectionInEdit = (section, inEdit) => {
    sectionsInEdit = sectionsInEdit.filter(s => s !== section);
    inEdit && sectionsInEdit.push(section);
    if (!inEdit) {
        profileIframeRef.current.contentWindow.postMessage({ action: "requestScrollToSection", section: section }, "*");
    }
}
const scrollOffset = dom => dom === window ? window.pageYOffset : dom.scrollTop;
const scrollTop = (el, toY, smooth = true) => {
    if (el.scrollTo) {
        const smoothScroll = smooth && ("scrollBehavior" in document.documentElement.style);
        if (smoothScroll) {
            el.scrollTo({ top: toY, behavior: "smooth" });
        } else {
            el.scrollTo(0, toY);
        }
    } else {
        el.scrollTop = toY;
    }
}

export const profileIframeRef = createRef();
export default observer(function ProfileView ({ componentRef }) {

    const containerRef = useRef();
    const jobsCount = useRef(null);
    const highlights = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    useImperativeHandle(componentRef, () => ({
        getSectionsInEdit: () => sectionsInEdit,
        getJobsCount: () => jobsCount.current,
        getHighlights: () => highlights.current,
    }))

    useEffect(() => {
        const load = async () => {
            try {
                const data = await get('api/getProfileIframeUrl', { lang: appStore.locale || 'en' })
                profileIframeRef.current.src = data.url;
            } catch (ex) {
                appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR;
                setIsLoading(false);
            }
        }
        load();
    }, [])

    useEffect(function connectToIFrame() {
        const onMessage = (e) => {
            const workHistoryIframe = profileIframeRef.current;
            if (!workHistoryIframe) {
                return;
            }
            switch (e.data.action) {
                case "load":
                    sectionsInEdit = []
                    setIsLoading(false);
                    break;
                case "loaded-work-history":
                    jobsCount.current = e.data.count;
                    break;
                case "loaded-highlights":
                    highlights.current = e.data.highlights;
                    break;
                case "msg":
                    window.GLG.Cmx.User.Show[e.data.type](e.data.text);
                    break;
                case "resize":
                    const height = Number(e.data.height || 0);
                    if (height > 0) {
                        profileIframeRef.current.style.height = Math.round(height) + 'px';
                    }
                    break;
                case "scroll":
                    const scrollY = Number(e.data.scrollY || 0);
                    if (!isNaN(scrollY)) {
                        const scroller = window.GLG.Cmx.Navigation.getNavLayout().scrollContainer || window;
                        const iframeTop = workHistoryIframe.getBoundingClientRect().top;
                        const toY = Math.round(scrollOffset(scroller) + scrollY + iframeTop);
                        scrollTop(scroller, toY, true);
                    }
                    break;
                case "editMode":
                    const section = e.data.section;
                    if (section) {
                        setSectionInEdit(section, e.data.value);
                    }
                    if (/work-history/.test(section)) {
                        jobsCount.current = e.data.count;
                    }
                    if (/nm-highlights/.test(section)) {
                        highlights.current = e.data.highlights;
                    }
                    break;
                default:
            }
        }
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);


    return (
        <Segment basic className="profile-view">
            <Segment
                textAlign={"center"}
                style={{ margin: 0, padding: "1px" }}
            >
                {isLoading && <Loader active inline style={{ marginTop: '10px' }} />}
                <div ref={containerRef} className="iframe-container">
                    <iframe
                        ref={profileIframeRef}
                        title="cm-home-profile-iframe"
                        />
                </div>
            </Segment>
        </Segment>
    )
})